import { render } from "./ButtonBlock.vue?vue&type=template&id=7f243568&ts=true"
import script from "./ButtonBlock.vue?vue&type=script&lang=ts"
export * from "./ButtonBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.27_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__